export const MetaSynchronousHeader = { meta: { synchronous: 'true' } }
